// components/Dashboard/LogisticsCard.jsx — per-route version
// Receives raw logistics transaction records for one route (sorted newest-first).
import React from "react"; // eslint-disable-line no-unused-vars
import { Text } from "@fluentui/react-components";
import { formatDate, safeNum } from "../../utils/helpers";
import { formatCurrency } from "../../utils/helpers";

export default function LogisticsCard({ route, records = [], style = {} }) {
  if (!records.length) return null;

  const latest   = records[0];
  const totalTrips = records.reduce((s, r) => s + safeNum(r.trips), 0);
  const totalSpend = records.reduce((s, r) => s + safeNum(r.spend), 0);
  const avgTrips   = totalTrips / records.length;

  // Mini sparkline: trips per week (last 8 weeks max)
  const spark = records.slice(0, 8).reverse();
  const maxT  = Math.max(...spark.map(r => safeNum(r.trips)), 1);

  return (
    <div style={{ background: "#fff", borderRadius: 16, padding: 24, boxShadow: "0 2px 12px rgba(0,0,0,0.06)", border: "1px solid #EDEBE9", ...style }}>
      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
        <div style={{ width: 36, height: 36, borderRadius: 10, background: "linear-gradient(135deg,#008272,#00A695)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 18 }}>🚚</div>
        <div>
          <Text weight="semibold" size={400} style={{ color: "#201F1E", display: "block" }}>{route}</Text>
          <Text style={{ fontSize: 11, color: "#8A8886" }}>Latest: {formatDate(latest.weekEnding)}</Text>
        </div>
      </div>

      {/* Sparkline — trips trend */}
      {spark.length > 1 && (
        <div style={{ display: "flex", alignItems: "flex-end", gap: 3, height: 40, marginBottom: 14 }}>
          {spark.map((r, i) => {
            const h = Math.max(4, (safeNum(r.trips) / maxT) * 40);
            const isLatest = i === spark.length - 1;
            return (
              <div
                key={i}
                title={`${formatDate(r.weekEnding)}: ${safeNum(r.trips)} trips`}
                style={{ flex: 1, height: h, borderRadius: 3, background: isLatest ? "#008272" : "#D1F0EB", transition: "height 0.2s" }}
              />
            );
          })}
        </div>
      )}

      {/* Latest week stats */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 12 }}>
        <div style={{ background: "#F3F2F1", borderRadius: 10, padding: "10px 12px" }}>
          <Text style={{ fontSize: 20, fontWeight: 700, color: "#008272", display: "block", lineHeight: 1.2 }}>{safeNum(latest.trips)}</Text>
          <Text style={{ fontSize: 11, color: "#605E5C" }}>Trips (latest wk)</Text>
        </div>
        <div style={{ background: "#F3F2F1", borderRadius: 10, padding: "10px 12px" }}>
          <Text style={{ fontSize: 14, fontWeight: 700, color: "#008272", display: "block", lineHeight: 1.5 }}>{formatCurrency(latest.spend, "₦")}</Text>
          <Text style={{ fontSize: 11, color: "#605E5C" }}>Spend (latest wk)</Text>
        </div>
      </div>

      {/* Period cumulative */}
      <div style={{ padding: "8px 12px", background: "#F0FFF8", borderRadius: 8, borderLeft: "3px solid #008272" }}>
        <Text style={{ fontSize: 11, fontWeight: 700, color: "#065F46", display: "block", marginBottom: 3 }}>Period Total ({records.length} weeks)</Text>
        <Text style={{ fontSize: 12, color: "#065F46" }}>
          {totalTrips.toLocaleString()} trips &nbsp;·&nbsp; {formatCurrency(totalSpend, "₦")} spend
          &nbsp;·&nbsp; avg {avgTrips.toFixed(1)} trips/wk
        </Text>
      </div>
    </div>
  );
}
